import { render, staticRenderFns } from "./MonthlyPaymentDetail.vue?vue&type=template&id=b8020248&scoped=true"
import script from "./MonthlyPaymentDetail.vue?vue&type=script&lang=js"
export * from "./MonthlyPaymentDetail.vue?vue&type=script&lang=js"
import style0 from "./MonthlyPaymentDetail.vue?vue&type=style&index=0&id=b8020248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_cache-loader@4.1.0_webpack@4.47.0_supports-_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8020248",
  null
  
)

export default component.exports